<!-- 大分类 -->
<template>
  <div class="content">
    <el-cascader-panel
      :props="defaultCate"
      :options="catedata"
      @change="handleChangeCate"
      @expand-change="expandChange1"
      ref="newclass"
    >
    </el-cascader-panel>
    <el-cascader
      :props="defaultCate"
      :options="catedata"
      @change="handleChangeCate"
      @expand-change="expandChange"
      ref="newclass">
    </el-cascader>
  </div>
  
</template>

<script>
import { getCateApi } from "@/api/mall";
import { mapGetters } from "vuex";
export default {
  computed:{
    ...mapGetters(["token", "app_id", "merch_id"])
  },
  data () {
    return {
      defaultCate:{
        label:"name",
        value:"id",
        children:"child",
      },
      catedata:[], //分类数据
    };
  },

  components: {},
  mounted(){
    this.getCate();
  },
  methods:{
    getCate(){
      let data = {
          token: this.token,
          app_id: this.app_id,
      };
      getCateApi(data).then(res => {
        console.log("分类数据",res);
        console.log(res);
        this.catedata = res.data;
      })
    },
    handleChangeCate(value) {
      console.log(value);
    },
    expandChange(value){
      let classfiy = this.$refs['newclass'];
      console.log("sss",classfiy );
      console.log(value);
    },
    expandChange1(value){
      let classfiy = this.$refs['newclass'];
      console.log("级联面板",classfiy );
      console.log(value);
    }
  }
}
</script>
<style lang= "scss" scoped>
</style>